import React from 'react'
import "./ProductDetail95.css"
function ProductDetail95() {
  return (
    <>
    <div>
        mnbv
    </div>
    </>
  )
}

export default ProductDetail95;
